var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-2",attrs:{"light":""}},[_c('v-toolbar',{attrs:{"dark":"","elevation":"0","color":"error"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("TITLE")))])],1),_c('v-card-text',_vm._l((_vm.paragraphs),function(paragraph,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(paragraph)}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }